module.exports = __webpack_public_path__ + "img/WICC.4976e4e2.png";